import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceCard.css';

function ServiceCard({ service }) {
  return (
    <div className="service-detail-card" style={{ borderLeft: `4px solid ${service.color}` }} aria-label={service.category}>
      <div className="service-body">
        <div className="service-header">
          <span className="service-icon-large">{service.icon}</span>
          <h2>{service.category}</h2>
        </div>
        <p className="service-description">{service.description}</p>
        <ul className="service-list">
          {service.items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
        <div className="service-controls">
          <Link to="/contact" className="btn btn-primary">
            Request Service
          </Link>
          {service.detailsPath && (
            <Link to={service.detailsPath} className="btn btn-outline">
              View Details
            </Link>
          )}
        </div>
      </div>
      {service.image && (
        <div className="service-image-box">
          <img src={service.image} alt={service.category} className="service-img" />
        </div>
      )}
    </div>
  );
}

export default ServiceCard;
